import { render } from "./player-item.template.html?vue&type=template&id=7f50369a&scoped=true"
import script from "./PlayerItem.vue?vue&type=script&lang=ts"
export * from "./PlayerItem.vue?vue&type=script&lang=ts"

import "./PlayerItem.vue?vue&type=style&index=0&id=7f50369a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7f50369a"

export default script